import { render, staticRenderFns } from "./section-layout.vue?vue&type=template&id=5c17f2a2&scoped=true"
import script from "./section-layout.vue?vue&type=script&lang=js"
export * from "./section-layout.vue?vue&type=script&lang=js"
import style0 from "./section-layout.vue?vue&type=style&index=0&id=5c17f2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17f2a2",
  null
  
)

export default component.exports